import React from 'react';
import './field-repository.scss';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import PropTypes from "prop-types";

export const options = [
    {
        category: 'Text',
        fields: [
            { value: 'Short Text Entry', label: 'Short Text', description: 'Store free-form text in a short text field', icon: 'TextCaseTitleRegular' },
            { value: 'Long Text Entry', label: 'Paragraph', description: 'Enter paragraph in a long text field', icon: 'TextDescriptionRegular' },
        ]
    },
    {
        category: 'Date & Time',
        fields: [
            { value: 'Date', label: 'Date', description: 'Use calendar to pick a specific date', icon: 'CalendarRegular' },
            { value: 'Time', label: 'Time Duration', description: 'Use calendar to pick a specific date', icon: 'HourglassHalfRegular' },
        ]
    },
    {
        category: 'Number',
        fields: [
            { value: 'Numeric (Integer)', label: 'Numeric (Integer)', description: 'Store a integer value', icon: 'NumberSymbolRegular' },
            { value: 'Numeric (Decimal)', label: 'Numeric (Decimal)', description: 'Store a decimal value', icon: 'NumberSymbolFilled' },
        ]
    },
    {
        category: 'Options',
        fields: [
            { value: 'Toggle', label: 'Toggle', description: 'Switch between On/Off values', icon: 'ToggleLeftRegular' },
            { value: 'Checkbox', label: 'Checkbox', description: 'Select multiple options from a list', icon: 'CheckboxCheckedRegular' },
            { value: 'Radio Buttons', label: 'Radio', description: 'Select one option from a list', icon: 'RadioButtonFilled'},
            { value: 'Dropdown', label: 'Dropdown', description: 'Select one option from a menu', icon: 'ChevronCircleDownRegular' },
            { value: 'Dependant Dropdown', label: 'Dependant Dropdown', description: 'Options in one menu depend on what you choose in another', icon: 'ChevronDoubleDownRegular', isDisabled: true  },
        ]
    },
    {
        category: 'Attachments',
        fields: [
            { value: 'URL', label: 'Link', description: 'Store a Link in different URI Schemes', icon: 'LinkRegular' },
            { value: 'File', label: 'File', description: 'Store different formats of file', icon: 'DocumentRegular' },
        ]
    },
    {
        category: 'Other',
        fields: [
            { value: 'Table', label: 'Table', description: 'Store Data in a table', icon: 'TableRegular' },
        ]
    },
]

const onKeyDown = (e, setFieldType, field) => {
    if (e.key === 'Enter' || e.key === ' ') {
        setFieldType(field);
    }
}

export const selectField = (option, setFieldType, isClickable, isDisabled = true) => {
    return (
        <div className='select-field-row'>
            {
                option.fields.map((field) => {
                    return <div tabIndex={0} disabled={isDisabled} className={`field-option-block field-option ${!field.isDisabled ? '' : 'field-option-block-disabled'}`} key={field?.label}
                        onClick={() => {
                            if (isClickable && !field?.isDisabled)
                                setFieldType(field)
                        }}
                        role='button'
                        onKeyDown={(e) => {
                            if (isClickable && !field?.isDisabled)
                                onKeyDown(e, setFieldType, field)
                        }}>
                        <div className='icon-circle'>
                            <FluentUiIcon name={field?.icon} size={20} />
                        </div>
                        <div>
                            <div className='field-title'>
                                {field?.label}
                            </div>
                            <div className='field-description '>
                                {field?.description}
                            </div>
                        </div>

                    </div>
                })
            }
        </div>
    )
}

const FieldOptions = ({ setFieldType }) => {

    return (
        <div className='field-options'>
            {options.map((option) => {
                return <div key={option.category}>
                    <div className='field-category'>{option.category}</div>
                    {selectField(option, setFieldType, true)}
                </div>
            })}
        </div>
    )
}

FieldOptions.propTypes = {
    setFieldType: PropTypes.func.isRequired,
};

export default FieldOptions;